<script>
import { mapActions, mapMutations, mapGetters } from "vuex";
import config from "@/modules/config/columns";
export default {
    created() {},
    props: {
        handlerCodeSearch: {
            type: Function,
            required: true
        }
    },
    data() {
        return {
            searchQuery: {
                id: "",
                name: "",
                code: ""
            },
            options: [
                {
                    value: "选项1",
                    label: "黄金糕"
                },
                {
                    value: "选项2",
                    label: "双皮奶"
                }
            ]
        };
    },
    methods: {
        addCodeModel() {
            this.$refs.edit.modelStatus(true);
        },
        handleReset() {
            console.log("重置");
        },
        ...mapActions("accountRules", ["addCode"]),
        ...mapMutations("accountRules", {
            changeCodeValue: "CHANGE_CODE_VALUE"
        })
    },
    computed: {
        ...mapGetters("accountRules", ["codeOption"]),
        config() {
            return config;
        }
    }
};
</script>
<template>
    <div class="name-search">
        <el-row :gutter="20">
            <el-col :span="5">
                <el-input
                    v-model="searchQuery.id"
                    placeholder="用户账号"
                    @change="changeCodeValue(searchQuery)"
                ></el-input>
            </el-col>

            <el-col :span="5">
                <el-select
                    v-model="searchQuery.code"
                    class="common-width"
                    placeholder="用户姓名"
                    @change="changeCodeValue(searchQuery)"
                >
                    <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    >
                    </el-option>
                </el-select>
            </el-col>
            <el-col :span="6">
                <el-button type="primary" @click="handlerCodeSearch"
                    >搜索</el-button
                >
                <el-button type="primary" @click="handleReset">重置</el-button>
                <el-button type="primary" @click="addCodeModel">新增</el-button>
            </el-col>
        </el-row>
    </div>
</template>
<style scoped lang="stylus">
.el-header
    line-height 60px
    padding 0 10px
.avatar-uploader
    display inline-block
    margin-left 80%

/deep/.el-date-editor.el-input, .el-date-editor.el-input__inner
    width auto
</style>
